"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const calculations_1 = require("@munters/calculations");
const initialState = {
    airIn: property_1.PropertyValueSet.fromString("temperature=20:Celsius;humidity=3:GramPerKilogram;pressure=101325:Pascal;flow=300:StandardCubicMeterPerHour"),
    airOut: property_1.PropertyValueSet.fromString("temperature=10:Celsius;humidity=3:GramPerKilogram"),
    power: property_1.PropertyValueSet.fromString("power=2000:Watt")
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case "air-power-tool/SET-PROPERTIES-AIR-IN":
            return Object.assign(Object.assign({}, state), { airIn: action.payload });
        case "air-power-tool/SET-PROPERTIES-AIR-OUT":
            return Object.assign(Object.assign({}, state), { airOut: action.payload });
        case "air-power-tool/SET-PROPERTIES-POWER":
            return Object.assign(Object.assign({}, state), { power: action.payload });
        case "air-power-tool/CALCULATE-POWER":
            return Object.assign(Object.assign({}, state), { power: calculatePower(state) });
        case "air-power-tool/CALCULATE-AIR-OUT":
            return Object.assign(Object.assign({}, state), { airOut: calculateAirOut(state) });
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
function calculatePower(state) {
    const temperatureIn = property_1.PropertyValueSet.getAmount("temperature", state.airIn);
    const humidityIn = property_1.PropertyValueSet.getAmount("humidity", state.airIn);
    const pressureIn = property_1.PropertyValueSet.getAmount("pressure", state.airIn);
    const flow = property_1.PropertyValueSet.getAmount("flow", state.airIn);
    const temperatureOut = property_1.PropertyValueSet.getAmount("temperature", state.airOut);
    const humidityOut = property_1.PropertyValueSet.getAmount("humidity", state.airOut);
    const power = calculations_1.Physics.AirCalculation.calculateAirTotalPowerForAirFlowAirInAirOut(temperatureIn, humidityIn, pressureIn, temperatureOut, humidityOut, pressureIn, flow);
    const finalPower = uom_1.Amount.lessThan(temperatureOut, temperatureIn)
        ? uom_1.Amount.neg(power)
        : power;
    return property_1.PropertyValueSet.fromProperty("power", property_1.PropertyValue.fromAmount(finalPower));
}
function calculateAirOut(state) {
    const temperatureIn = property_1.PropertyValueSet.getAmount("temperature", state.airIn);
    const humidityIn = property_1.PropertyValueSet.getAmount("humidity", state.airIn);
    const pressureIn = property_1.PropertyValueSet.getAmount("pressure", state.airIn);
    const flow = property_1.PropertyValueSet.getAmount("flow", state.airIn);
    const power = property_1.PropertyValueSet.getAmount("power", state.power);
    const airOut = calculations_1.Physics.AirCalculation.applyTotalPowerAsEnthalpyChangeOnFlowingAir(temperatureIn, humidityIn, pressureIn, pressureIn, flow, power);
    const temperatureOut = property_1.PropertyValue.fromAmount(airOut.temperature);
    const humidityOut = property_1.PropertyValue.fromAmount(airOut.humidity);
    return property_1.PropertyValueSet.merge(property_1.PropertyValueSet.fromProperty("temperature", temperatureOut), property_1.PropertyValueSet.fromProperty("humidity", humidityOut));
}
//# sourceMappingURL=reducer.js.map